import PropTypes from "prop-types";
import { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from "@mui/material";
import { useRecordContext, useNotify } from "react-admin";
import RequestQuoteModal from "./RequestQuoteModal";

const RequestQuoteButton = ({ agentId }) => {
  const record = useRecordContext();
  const notify = useNotify();
  const [openModal, setOpenModal] = useState(false);
  const [isFetchingPrices, setIsFetchingPrices] = useState(false);
  const [price, setPrice] = useState(0);
  const isBookingCompleted = record.bookingCompleted;

  const request = new Request(
    `${
      process.env.REACT_APP_API_PLATFORM_ENDPOINT
    }/services/pricing/pull-a-part?quote_id=${Number(record.originId)}`,
    {
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      }),
      method: "GET",
    }
  );

  const fetchPrices = async () => {
    setIsFetchingPrices(true);
    await fetch(request)
      .then((response) => response.json())
      .then((responseJSON) => {
        if (responseJSON.status !== "success") {
          setIsFetchingPrices(false);
          notify(responseJSON.error_message, { type: "error" });
          throw Error(responseJSON.Error);
        }

        setPrice(responseJSON.price);
        setOpenModal(true);
        setIsFetchingPrices(false);
      });
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  // Agent ID 2 is for PullaQuote
  if (agentId === 2) {
    return (
      <>
        <Button
          variant="contained"
          className={`${
            isBookingCompleted
              ? "buttonMarginTop"
              : "view-agents__list-table_request-btn"
          }`}
          fullWidth
          disabled={isBookingCompleted || isFetchingPrices}
          color="secondary"
          onClick={fetchPrices}
        >
          Get Quotes
        </Button>
        <Dialog onClose={handleCloseModal} open={openModal}>
          <DialogContent sx={{ paddingBottom: 0 }}>
            <DialogContentText fontWeight="bold">
              Pull-A-Part quote: ${price}
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={{ paddingTop: 0 }}>
            <Button onClick={handleCloseModal} autoFocus>
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </>
    );
  } else {
    return <RequestQuoteModal agentId={agentId} />;
  }
};

RequestQuoteButton.propTypes = {
  agentId: PropTypes.number,
};

export default RequestQuoteButton;
